import { Viewer } from "@shared";
import style from "./PreviewAvatarSection.module.scss";
import { createPlayerSettings } from "../../utils/shared";
import { IRootState } from "../../redux/store";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const PreviewAvatarSection: React.FC = () => {
	const { t } = useTranslation('general');
	const { i18n } = useTranslation();
  	const currentLang = i18n.language as 'ru' | 'en';
	const formData = useSelector((state: IRootState) => state.avatarForm);
	const brainId = useSelector((state: IRootState) => state.avatar.brainId);
	const avatarId = useSelector((state: IRootState) => state.avatar.avatarId);
	const isNeural = useSelector((state: IRootState) => state.avatar.type) === "2d";
	const avatarSettings = createPlayerSettings(formData, brainId, avatarId, isNeural);

    return (
        <div className={style.avatarPreviewContainer}>
			<div className={style.avatarPreviewHeader}>
				<div className={style.previewDescriptionText}>
					<h3 className={style.previewDescriptionTitle}>{t("test_ai_assistant")}</h3>
					<p>{t("review_background_prompt_voice_behavior")}</p>
				</div>
			</div>
		    <div className={`${style.iframeWrapper}`}>
				<Viewer settings={avatarSettings} lang={currentLang}/>
			</div>
		</div>
    );
};

export default PreviewAvatarSection;